
<template>
    <div class="container">
        <mt-header fixed title="消息管理" class="head" >
          <!-- <mt-button slot="right" class="iconfont icon-calendar" @click="todate()"></mt-button> -->
        </mt-header>
      <div>
        <mt-loadmore :top-method="loadTop"  ref="loadmore">
          <div class="" v-infinite-scroll="scroll_load" :infinite-scroll-disabled="loading" infinite-scroll-distance="1">
            <div class="item" v-for="(item,index) in messageList" :key="index" style='position:relative;'>
              <!--<div class=""><span>名称</span>：<span>{{item.title}}</span></div>-->
              <div class="title"><span>{{item.title}}</span></div>
              <div class="c_m_t_10 c_m_l_1 c_box"><span>操作</span> ：<span>{{item.content}}</span></div>
              <div class="c_m_t_10 c_m_l_1 c_box"><span>日期</span> ：<span>{{ item.sendtime | getDatetime}}</span></div>
              <img v-show='!item.state' src='../assets/images/new.png' style='position:absolute;top:0;right:0;'>
            </div>
            <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="messageList.length<1 && (!showLoading)">
              <div class="c_gray">您还没有消息</div>
            </div>
            <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="showLoading">
              <mt-spinner type="snake" color="#00ccff" :size="20" v-show="!stopload"></mt-spinner>
              <span v-show="stopload">已经是最后一页了</span>
            </div>
          </div>
        </mt-loadmore>
      </div>
    </div>

</template>

<script>
export default {
  data: function () {
    return {
      allLoaded:false,
      page_params:{
        pageIndex:0,
        pageSize:5,
        totalPages:1,
        topStatus:'',
        bottomDropText:'释放加载',
      },
      messageList: [
        // {
        // title:'title',
        // content:'cpontent',
        // sendtime:11111
      // }
      ],

      // 无限滚动
      loading:false,
      showLoading:false,
      stopload:false,
    }
  },
  computed:{
  },
  mounted:function(){
    this.$indicator.close();
    // this.loadList();
  },
  methods:{
    loadList:function (fun) {
        var $that = this;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getMessageList,{
          pageIndex:$that.page_params.pageIndex,
          pageSize:$that.page_params.pageSize,
          'sortField':'ts',
          'sortDirection':'desc',
          //'search_messageType':'0'
        },function (res) {
            if(res.status ==200 ){
              var msg = res.data.detailMsg.data;
              $that.page_params.pageIndex = msg.number+1;
              $that.page_params.totalPages = msg.totalPages;
              if(msg.number ==0){
                $that.messageList = msg.content;
              }else if(msg.number < msg.totalPages){
                $that.messageList = $that.messageList.concat(msg.content);
              }
            }
            if(fun)fun();
            $that.$indicator.close();
        });
    },
    loadTop:function () {
        var $that = this;
        this.page_params.bottomDropText = '释放加载';
        $that.page_params.pageIndex = 0;
        $that.loadList(function () {
          setTimeout(function () {
              $that.$refs.loadmore.onTopLoaded();
          },500);
        });
    },
    loadBottom:function () {
      var $that = this;
      var pageIndex = $that.page_params.pageIndex + 1;
      var totalPages = $that.page_params.totalPages;
      if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.page_params.bottomDropText = '已经最后一页了';
          $that.$refs.loadmore.onBottomLoaded();
          // $that.allLoaded = true;
      }else{
          $that.page_params.pageIndex = pageIndex;
          $that.loadList(function () {
            setTimeout(function () {
              $that.$refs.loadmore.onBottomLoaded();
            },500);
          });
      }
    },
    js_detail:function(data){
        console.log(data);
    },

    scroll_load:function () {
      if(this.loading){
        return;
      }
      this.loading = true;
      this.showLoading = true;
      var $that = this;
      var pageIndex = $that.page_params.pageIndex;
      var totalPages = $that.page_params.totalPages;
      if(pageIndex >= totalPages){
        // 已经到最后一页了
        this.stopload = true;
        setTimeout(function () {
          $that.showLoading = false;
          $that.loading = false;
        },2500);
      }else{
        this.stopload = false;
        $that.loadList(function () {
          $that.showLoading = false;
          $that.loading = false;
        });
      }
    },

  },

}
</script>

<style scoped>
  .container{
    font-size:4vw;
  }
  ::-webkit-input-placeholder{
    font-size: 3.065vw;
  }
    .item {
        width: 100%;
        /*margin-bottom:3.226vw;*/
        text-align: left;
        box-sizing: border-box;
        padding: 5vw;
        word-wrap:break-word;
        word-break:break-all;
        background: #fff;
        border-bottom: 1px solid #ccc;
    }
    .item .title{
      font-weight: bold;
      font-size: 4.5vw;
    }
  ul{
    list-style:none;
    margin:0;
    padding:0;
    /*min-height: 80vh;*/
  }
  /*loadmore*/
  /*.loadmore-container{*/
    /*height: 82vh;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/message.vue